import { Grid, InputLabel, Typography } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';
import { NominalExpenseCode_UpdateDescription, NominalExpenseCodeGroups_UpdateDescription } from '../../../../Core/Service/ManageAccount/manageAccountService';
import AppContext from '../../../../App/AppContext';

const ExpenseCodeGroupsModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        description: props.selectedRecord.description,
        code: props.selectedRecord.code,
        keyloopDesc: props.selectedRecord.keyloopDesc
    });

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => {
            return { ...st, [name]: value };
        });
    };

    const handleSubmit = async (e) => {
        const data =
            props.selectedColumnName === 'expenseCode'
                ? { code: state.code, description: state.description }
                : { groupCode: state.code, description: state.description };

        const serviceCall = props.selectedColumnName === 'expenseCode' ? NominalExpenseCode_UpdateDescription : NominalExpenseCodeGroups_UpdateDescription;

        try {
            const res = await serviceCall(data);
            if (res.success) {
                showToast(res.data.message);
                props.onClose(true);
            } else {
                showToast(res.data || 'Error while updating description');
                console.error(res);
            }
        } catch (error) {
            console.error('Error while updating description:', error);
            showToast('An error occurred while updating.');
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2} justifyContent="space-between">
                        <Grid item xs={6}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <InputLabel shrink>{props.selectedColumnName === 'expenseCode' ? 'Expense Code' : 'Expense Group'}</InputLabel>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6">{state.code}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <InputLabel shrink>Keyloop Description</InputLabel>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6">{state.keyloopDesc}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <InputLabel shrink>Management Account Description</InputLabel>
                    <TextBox type="text" onChange={handleFieldChange} name="description" value={state.description} inputProps={{ maxLength: 50 }} />
                </Grid>

                <Grid item xs={12} style={{ marginBottom: 10 }}>
                    <SecondaryButton fullWidth onClick={handleSubmit}>
                        Save
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default ExpenseCodeGroupsModal;
